module.exports = __webpack_public_path__ + "img/11.61b781f5.png";